const state = {
  caseId: null,
  exceptionDeal: {
    flowRunningComplete: false,
    flowRunningSuccess: true,
    otherException: false,
    exceptionMessage: ''
  },
  // 异常信息处理
  projectData: {
    title: window.ProjectTitle,
    apiUrl: window.ServerUrl,
    fileUrl: window.FileUrl,
    isOpenChangepassword: window.IsOpenChangepassword
  },
  // 数据源列表
  resourceList: []
}

const mutations = {
  // 设置数据源
  setResourceList (state, payload) {
    state.resourceList = payload
  },
  setCaseId (state, payload) {
    state.caseId = payload
  }
}

export default {
  state,
  mutations
}
